

module.exports = __webpack_require__.stylable.create(
    "Title504510542",
    {"classes":{"root":"Title504510542__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "Title504510542",
    null
);
